/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from "@msdyn365-commerce/core";
import {
  getSpecificCaseAsync,
  getCaseNotesAsync,
} from "../actions/ClaimManagementDataActionExtension.g";
import { IGetCaseNotesResponse } from "../actions/ClaimManagementDataServiceEntities.g";
/**
 * Getnotes Input Action
 */
export class GetnotesInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor() {}

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `zxvc`;
  public getCacheObjectType = () => "zxcv";
  public dataCacheType = (): Msdyn365.CacheType => "none";
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetnotesData {
  text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new GetnotesInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
  input: GetnotesInput,
  ctx: Msdyn365.IActionContext
): Promise<IGetCaseNotesResponse> {
  const specificCaseId = ctx.requestContext.query?.specificCaseId!;

  const result = await getSpecificCaseAsync(
    { callerContext: ctx },
    specificCaseId
  );
  const notes = await getCaseNotesAsync(
    { callerContext: ctx },
    result.Data?.Value![0].IncidentId!
  );
  return notes;
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<IGetCaseNotesResponse>>action,
  // TODO: Give your data action a unique id
  id: "Getnotes",
  input: createInput,
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
});
